import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Product } from '../../../store/app.model';
import { FooterComponent } from '../footer/footer.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-recall-view',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FooterComponent,
    ButtonModule,
    InputTextModule,
    TextareaModule
  ],
  templateUrl: './recall-view.component.html',
  styleUrls: ['./recall-view.component.css']
})
export class RecallViewComponent implements OnInit {
  @Input() product: Product | null = null;
  
  contactForm: FormGroup;
  isSubmitting = false;
  submitSuccess = false;

  constructor(private fb: FormBuilder) {
    this.contactForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    // If we had a backend input for default message or subject, we could set it here
  }

  get recallData() {
    return this.product?.qrProductItem?.recallProduct;
  }

  get productImage() {
    // Try to get the first product image, fallback to logo or placeholder
    if (this.product?.productImages?.length) {
      return this.product.productImages[0].url;
    }
    return this.product?.logo || 'assets/images/placeholder-product.png';
  }

  onSubmit() {
    if (this.contactForm.valid) {
      this.isSubmitting = true;
      // Simulate API call
      setTimeout(() => {
        console.log('Form submitted', this.contactForm.value);
        this.isSubmitting = false;
        this.submitSuccess = true;
        this.contactForm.reset();
      }, 1000);
    } else {
        this.contactForm.markAllAsTouched();
    }
  }

  // Helper to extract the footer content if it exists in the product design template
  get footerContent() {
    return this.product?.productDesignTemplate?.pageContent?.find(c => c.slug.startsWith('footer'));
  }
}
